const info = {
  ZH: {
    //中文翻译
    Login: "会员登录",
    wxLogin: "微信登录",
    LoginButton: "登 录",
    sever: "享受更多贴心服务",
    zhanghao: "登录帐号",
    mima: "登录密码",
    loginInput: "请输入登录账号",
    register: "请输入登录密码",
    goLogin: "立即登录",
    noZhanghao: "还没有账号？立即",
    registerText: "注册",
    otherLogin: "其他方式登录",
    version: "版本号",
    setting: "设置",
    logout: "退出登录",
    changePwd: "修改密码",
  },
  EN: {
    //英文翻译
    Login: "Member login",
    wxLogin: "Login by WeChat",
    LoginButton: "Login",
    sever: "Enjoy more considerate services",
    zhanghao: "account",
    mima: "password",
    loginInput: "Please input account",
    register: "Please input password",
    goLogin: "Log in now",
    noZhanghao: "Don't have an account yet?",
    registerText: "Register now",
    otherLogin: "Other ways to login",
    version: "Version",
    setting: "Setting",
    logout: "Log out",
    changePwd: "Change password",
  },
};
export default info;
